/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import Relay from 'react-relay';
import urlMapping from "../../../../app/URLMapping";
import EditorWithSaver from '../../../../fw/EditorWithSaver.react';
import {declareEditEntity} from "../../../../../common/fw/MetaDataHelper.ts";
import HTTPAuth from "../../../../channel-defs/handlers/HTTPAuth.react";
import types from '../../../../../common/model-api/types';
import {RELATION_TYPE_MANUAL} from "../../../../../common/model-api/RelationDefType";
import {safeJSONparse} from "../../../../../common/util/safeJSONparse";

export const messages = defineMessages({
    url: {id: 'AddRelationEdit.url', 'defaultMessage': 'URL:'},
    urlDescription: {id: 'AddRelationEdit.urlDescription', 'defaultMessage': 'URL must start with https://. Unsecure connections will not work in most applications.'},
    height: {id: 'AddRelationEdit.height', 'defaultMessage': 'Height in pixels:'},
    heightDescription: {id: 'AddRelationEdit.heightDescription', 'defaultMessage': 'Keep empty for dynamic height according to {productName} panel height.'},
    save: {id: 'AddRelationEdit.save', 'defaultMessage': 'Save Addon configuration'},
});

export const handlerName = "add-relation";

class AddRelationEdit extends React.Component {

    static propTypes = {
        channelAddon: PropTypes.object.isRequired,
        intl: PropTypes.object,
        save: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            data: safeJSONparse(this.props.channelAddon.options)
        };
    }

	// eslint-disable-next-line max-params
    _saver = (metadata, isCreate, columns, data) => {
        return ({
            save: () => {
                return this.props.save(this.state.data);
            }
        });
    }

    collectMappableFields() {
        let list = {};

        list["relationDef"] = {
            name: "Relation",
            type: "relation",
            to: () => types['relationDefs'],
        };

        return declareEditEntity({
            entity: HTTPAuth.handlerName,
            name: HTTPAuth.displayName,
            fields: (types) => {
                return list;
            }
        });
    }

    render() {
        let fields = this.collectMappableFields();
        let relationDefs = [
             ...this.props.channelAddon.channel.relationDefs .edges.map(({node}) => ({...node, 'direction': 'from', id: node.realId})),
             ...this.props.channelAddon.channel.relationDefs2.edges.map(({node}) => ({...node, 'direction': 'to', id: node.realId}))
        ].filter((relationDef) => {
            return (relationDef.type === RELATION_TYPE_MANUAL);
        });

        return (
            <EditorWithSaver
                buttonTitle={this.props.intl.formatMessage(messages.save)}
                columns={{
                    'relationDef': {
                        values: relationDefs,
                        display: (item) => {
                            let fromName = item.fromChannel.name;
                            if (!fromName) {
                                fromName = item.fromChannel.channelDef.name;
                            }

                            let toName = item.toChannel.name;
                            if (!toName) {
                                toName = item.toChannel.channelDef.name;
                            }

                            if (item['name']) {
                                return item['name'] + ' (' + fromName + ' - ' + toName + ")";
                            } else {
                                return fromName + ' - ' + toName;
                            }
                        },
                        onChange: (e, key) => {
                            let data = this.state.data;
                            let relationDef = relationDefs.find((relationDef) => key === relationDef.id);
                            data['relationDef_id']  = relationDef.realId;
                            data['direction'] = relationDef.direction;

                            if (relationDef.direction === 'from') {
                                data['toChannel_id'] = relationDef['toChannel_id'];
                                data['toEntityDef_id'] = relationDef['toEntity_id'];
                            } else {
                                data['toChannel_id'] = relationDef['fromChannel_id'];
                                data['toEntityDef_id'] = relationDef['fromEntity_id'];
                            }

                            this.setState(data);
                        },
                    },
                }}
                data={this.state.data}
                metadata={fields}
                onSuccess={() => {}}
                saver={this._saver}
                urlMapping={urlMapping}
            >

            </EditorWithSaver>
        );
    }
}

export default Relay.createContainer(injectIntl(AddRelationEdit), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        channelAddon: () => {
            return Relay.QL`
                fragment on ChannelAddon {
                    id,
                    realId,
                    name,
                    options,
                    channel {
                        id,
                        name,
                        organisation_id,
                        relationDefs(first: 100) {
                            edges {
                                node {
                                    id,
                                    realId,
                                    name,
                                    type,
                                    organisation {
                                        id,
                                        realId,
                                    },
                                    organisation_id,
                                    fromChannel_id,
                                    fromChannel {
                                        id,
                                        realId,
                                        name,
                                        channelDef {
                                            id,
                                            realId,
                                            name
                                        }
                                    },
                                    toChannel_id,
                                    toChannel {
                                        id,
                                        name,
                                        channelDef {
                                            id,
                                            realId,
                                            name
                                        }
                                    },
                                    fromEntity_id,
                                    fromEntity {
                                        id,
                                        realId,
                                        name,
                                        key
                                    },
                                    toEntity_id,
                                    toEntity {
                                        id,
                                        realId,
                                        name,
                                        key
                                    },
                                }
                            },
                        },
                        relationDefs2(first: 100) {
                            edges {
                                node {
                                    id,
                                    realId,
                                    name,
                                    type,
                                    organisation {
                                        id,
                                        realId,
                                    },
                                    organisation_id,
                                    fromChannel_id,
                                    fromChannel {
                                        id,
                                        realId,
                                        name,
                                        channelDef {
                                            id,
                                            realId,
                                            name
                                        }
                                    },
                                    toChannel_id,
                                    toChannel {
                                        id,
                                        realId,
                                        name,
                                        channelDef {
                                            id,
                                            realId,
                                            name
                                        }
                                    },
                                    fromEntity_id,
                                    fromEntity {
                                        id,
                                        realId,
                                        name,
                                        key
                                    },
                                    toEntity_id,
                                    toEntity {
                                        id,
                                        realId,
                                        name,
                                        key
                                    },
                                }
                            },
                        }
                    }
                }`;
        }
    }
});
